import React from 'react';
import { classNames } from './classNames';
import FormLabel from './FormLabel';
import FormText from './FormText';

interface FormFieldProps extends React.HTMLAttributes<HTMLDivElement> {
  label: React.ReactNode;
  htmlFor?: string;
  helpText?: React.ReactNode;
  error?: React.ReactNode;
  labelClassName?: string;
}

const FormField: React.FC<FormFieldProps> = ({
  label,
  htmlFor,
  helpText,
  error,
  labelClassName,
  className,
  children,
  ...props
}) => (
  <div className={classNames('mb-3', className)} {...props}>
    <FormLabel htmlFor={htmlFor} className={labelClassName}>
      {label}
    </FormLabel>
    {children}
    {helpText && <FormText>{helpText}</FormText>}
    {error && <div className="invalid-feedback d-block">{error}</div>}
  </div>
);

export default FormField;
